import { appContext } from "ui-common/appContext";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const profileDataQueryKey = "profileData";

export const profileDataQueryOptions = queryOptions({
  queryKey: [profileDataQueryKey],
  queryFn: async () => {
    await appContext.ready;
    if (!appContext.isAuthenticated) return null;
    return rpc(profileDataQueryKey, undefined);
  },
});
